export default __webpack_public_path__ + "static/media/crumble.29540430.jpg";